module.exports = __webpack_public_path__ + "img/cardReport.624ccb28.svg";